import { axiosInstance } from './config/instance'
import { CONSOLE_API_URL, SERVER } from './config/url'

const JOURNAL_URL = `${SERVER}/${CONSOLE_API_URL}`
const ENTITY = 'journal'

export const journal = Object.freeze({
  async fetchList(params) {
    const response = await axiosInstance.get(`${JOURNAL_URL}/${ENTITY}`, { params })
    return response.data
  },
})
